import {MemoAggregation} from "./MemoAggregation";

export class CustomMemoAggregation<T>{

  memoAggregation = new MemoAggregation();
  content: T;
  forceApprovalByManager: boolean;

}
